import styles from "./TodoInput.module.css";
import { useState, useRef } from "react";

function TodoInput({ onAddTodo }) {
  const [inputValue, setInputValue] = useState("");
  const [error, setError] = useState("");
  const inputRef = useRef(null);

  const handleAddTodo = () => {
    if (inputValue.trim() === "") {
      setError("Please enter a todo item.");
      return;
    }
    onAddTodo(inputValue);
    setInputValue("");
    setError("");
    inputRef.current.focus();
  };

  return (
    <div className={styles.inputContainer}>
      <input
        ref={inputRef}
        className={styles.todoInput}
        value={inputValue}
        onChange={(e) => setInputValue(e.target.value)}
        placeholder="Enter task..."
      />
      <button
        className={styles.addTodoButton}
        onClick={handleAddTodo}
        aria-label="Add a new todo item"
      >
        Add Todo
      </button>
      {error && <p className={styles.error}>{error}</p>}
    </div>
  );
}

export default TodoInput;
